import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import axiosInstance from '../axiosInterceptor'
import { toast } from 'react-toastify'
import { ImageLink } from '../constants'
import CommonEditor from './CommonEditor'

const AddAbout = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state
    const [data, setData] = useState({
        title: editData?.title || '',
        subTitle: editData?.subTitle || '',
        description: editData?.description || '',
        specTitle: editData?.specTitle || '',
        specSubTitle: editData?.specSubTitle || '',
        contentImg: editData?.contentImg || '',
        bannerImg: editData?.bannerImg || '',
    });
    const [errors, setErrors] = useState({
        title: '',
        subTitle: '',
        description: '',
        specTitle: '',
        specSubTitle: '',
        contentImg: '',
        bannerImg: '',
    });

    const handleChange = (e) => {
        const { name, files, value } = e.target;
        if (name === 'contentImg' || name === 'bannerImg') {
            setData({ ...data, [name]: files.length > 0 ? files[0] : null });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;


        if (!data.title.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                title: 'Title is required'
            }));
            hasErrors = true;
        }
        if (!data.subTitle.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                subTitle: 'Sub title is required'
            }));
            hasErrors = true;
        }
        // if (!data.description.trim()) {
        //     setErrors((prevErrors) => ({
        //         ...prevErrors,
        //         description: 'Description is required'
        //     }));
        //     hasErrors = true;
        // }
        if (!data.specTitle.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                specTitle: 'Spec title is required'
            }));
            hasErrors = true;
        }
        if (!data.specSubTitle.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                specSubTitle: 'Spec sub title is required'
            }));
            hasErrors = true;
        }

        if (!data.contentImg) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                contentImg: 'Content img is required'
            }));
            hasErrors = true;
        }
        if (!data.bannerImg) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                bannerImg: 'Banner img is required'
            }));
            hasErrors = true;
        }

        // If there are errors, stop further processing
        if (hasErrors) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("subTitle", data.subTitle);
            formData.append("description", data.description);
            formData.append("specTitle", data.specTitle);
            formData.append("specSubTitle", data.specSubTitle);

            if (data.contentImg instanceof File) {
                formData.append("contentImg", data.contentImg);
            }
            if (data.bannerImg instanceof File) {
                formData.append("bannerImg", data.bannerImg);
            }

            const response = await axiosInstance.post(`about/createAbout`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/about");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };


    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("title", data.title);
            formData.append("subTitle", data.subTitle);
            formData.append("description", data.description);
            formData.append("specTitle", data.specTitle);
            formData.append("specSubTitle", data.specSubTitle);

            if (data.contentImg instanceof File) {
                formData.append("contentImg", data.contentImg);
            }
            if (data.bannerImg instanceof File) {
                formData.append("bannerImg", data.bannerImg);
            }
            const response = await axiosInstance.put(`about/updateAbout/${editData?._id}`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/about");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };


    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mx-4 mt-5">
                    <h3 className="page-title">Add About </h3>
                </div>
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="col-md-8">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit} >
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Title
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="title"
                                                name="title"
                                                placeholder="Enter title"
                                                value={data.title}
                                                onChange={handleChange}
                                            />
                                            {errors.title && <p className="text-danger">{errors.title}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Sub Title
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="subTitle"
                                                name="subTitle"
                                                placeholder="Enter subtitle"
                                                value={data.subTitle}
                                                onChange={handleChange}
                                            />
                                            {errors.subTitle && <p className="text-danger">{errors.subTitle}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Description
                                        </label>
                                        <div className="col-sm-9">
                                            <CommonEditor
                                                value={data.description}
                                                placeholder='Enter content ...'
                                                onChange={(value) => handleChange({ target: { name: 'description', value } })}
                                            />
                                            {errors.description && !data?.description?.trim() && (
                                                <div className="text-danger">Description is required</div>
                                            )}
                                        </div>
                                        {/* <div className="col-sm-9">
                                            <textarea
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="description"
                                                name="description"
                                                placeholder="Enter description"
                                                value={data.description}
                                                onChange={handleChange}
                                                style={{ height: '150px' }}
                                            />
                                            {errors.description && <p className="text-danger">{errors.description}</p>}
                                        </div> */}
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Specifications Title
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="specTitle"
                                                name="specTitle"
                                                placeholder="Enter sub title"
                                                value={data.specTitle}
                                                onChange={handleChange}
                                            />
                                            {errors.specTitle && <p className="text-danger">{errors.specTitle}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Specifications Sub Title
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="specSubTitle"
                                                name="specSubTitle"
                                                placeholder="Enter sub title"
                                                value={data.specSubTitle}
                                                onChange={handleChange}
                                            />
                                            {errors.specSubTitle && <p className="text-danger">{errors.specSubTitle}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Banner Img
                                        </label>

                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="bannerImg"
                                                name="bannerImg"
                                                placeholder="Enter banner img"
                                                // value={data.desktopImg}
                                                onChange={handleChange}
                                            />
                                            {errors.bannerImg && <p className="text-danger">{errors.bannerImg}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Content Img
                                        </label>

                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="contentImg"
                                                name="contentImg"
                                                placeholder="Enter content img"
                                                // value={data.desktopImg}
                                                onChange={handleChange}
                                            />
                                            {errors.contentImg && <p className="text-danger">{errors.contentImg}</p>}
                                        </div>
                                    </div>
                                    <div className='text-center'>
                                        <Link to="/about"><button className="btn btn-secondary mr-2">
                                            Back </button></Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 stretch-card">
                        <div className="card">
                            {data.bannerImg &&
                                <div className="w-100 h-80 text-center mb-4">
                                    <p className="mt-3">Banner Image Preview</p>
                                    <br />
                                    {data.bannerImg instanceof File ? (
                                        <img src={URL.createObjectURL(data.bannerImg)} alt="Preview" className="w-50 preview-img" />
                                    ) : (
                                        <img src={ImageLink(data.bannerImg)} alt="Preview" className="w-50 preview-img" />
                                    )}
                                </div>
                            }
                            <hr />
                            {data.contentImg &&
                                <div className="w-100 h-80 text-center mb-4">
                                    <h6 className="mt-3">Content Image Preview</h6>
                                    <br />
                                    {data.contentImg instanceof File ? (
                                        <img src={URL.createObjectURL(data.contentImg)} alt="Preview" className="w-50 preview-img" />
                                    ) : (
                                        <img src={ImageLink(data.contentImg)} alt="Preview" className="w-50 preview-img" />
                                    )}
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddAbout;